const tr = {
  reportIdsIntegration: {
    attributes: {
      evolutionId: 'ID',
      userName: 'Nome do Usuário',
      userCpf: 'CPF',
      userCns: 'CNS',
      doctorName: 'Médico',
      doctorCpf: 'CPF do Médico',
      entry: 'Início do Atendimento',
      exit: 'Fim do Atendimento',
      integrationId: 'ID Integração',
      integrationResponse: 'Motivo',
      integrationStatus: 'Status da Integração',
      statusDescription: 'Descrição do Status',
      created: 'Criado em',
    },
    extras: {
      startDate: 'Data Inicial',
      endDate: 'Data Final',
      doctorName: 'Nome do Médico',
      search: 'Nome do Usuário',
      integrationStatus: 'Status',
    }
  }
};

export default tr;
